import { isHTMLOrSVGElement } from '../dom/node';
import {
  applyStyleToElement,
  applyStyleToRange,
  getInheritedStyleForNode,
  hasInheritedStyleForNode,
  removeStyleFromElement,
  removeStyleFromRange,
  StyleSpec,
} from '../dom/style';

const FONT_FAMILY_SPEC: StyleSpec = {
  stylePropertyName: 'font-family',
  fontElementAttributeName: 'face',
};

export function nodeHasFontFamily(node: Node, container: Node): boolean {
  return hasInheritedStyleForNode(container, node, FONT_FAMILY_SPEC);
}

export function getFontFamilyForNode(node: Node, container: Node): string {
  return getInheritedStyleForNode(container, node, FONT_FAMILY_SPEC);
}

export function removeFontFamilyFromElement(element: Element): Node | null {
  return isHTMLOrSVGElement(element) ? removeStyleFromElement(element, FONT_FAMILY_SPEC) : element;
}

export function removeFontFamilyFromRange(container: Node, range: Range): Range {
  return removeStyleFromRange(container, range, FONT_FAMILY_SPEC);
}

export function applyFontFamilyToElement(element: HTMLElement | SVGElement, fontFamily: string): void {
  applyStyleToElement(element, FONT_FAMILY_SPEC, fontFamily);
}

export function setFontFamilyInRange(container: Node, range: Range, fontFamily: string): Range {
  return applyStyleToRange(container, range, FONT_FAMILY_SPEC, fontFamily);
}
